export const mergeObjects = (baseObject, targetObject) => {
  if (!baseObject) return targetObject;
  if (!targetObject) return baseObject;

  const answer = { ...targetObject };

  // override with the template
  for (let key in baseObject) {
    answer[key] =
      // eslint-disable-next-line no-prototype-builtins
      !targetObject.hasOwnProperty(key) || targetObject[key] === '' || targetObject[key] === null
        ? baseObject[key]
        : targetObject[key];
  }

  return answer;
};

export const extractFieldsFromTemplate = (template) => {
  if (!template?.data) {
    return null;
  }
  return template.data.attributes;
};
